import { useMemo, useState } from 'react';

import { matchesLineItemSearch } from '../../../helpers/lineItemSearch';
import { LineItemEntry } from '../../../types';

export const useLineItemSearch = (products: Array<LineItemEntry>) => {
  const [query, setQuery] = useState('');
  const filteredProducts = useMemo(
    () => products.filter((product) => matchesLineItemSearch(product, query)),
    [products, query],
  );
  const showNoResults = filteredProducts.length === 0 && query.trim() !== '';

  return { query, setQuery, filteredProducts, showNoResults };
};
